$(document).ready(function () {
	$('form[data-form-loader]').submit(function () {
		let text = $(this).data('btn-text');

		if (text) {
			$(this).find('button[type=submit]').each(function (i, e) {
				$(e).data('prev-text', $(e).text())
					.attr('disabled', 'disabled')
					.text(text);
			});
		}
	}).on('reload-btn', function () {
		$(this).find('button[type=submit]').each(function (i, e) {
			$(e).removeAttr('disabled', 'disabled')
				.text($(e).data('prev-text') || $(e).text())
		});
	});
});